import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["postalCode", "prefecture", "city", "ageDisplay"]

  // 年齢を計算して表示
  calculateAge(event) {
    const birthDate = new Date(event.target.value)
    if (!birthDate || isNaN(birthDate.getTime())) {
      this.clearAgeDisplay()
      return
    }

    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }

    this.displayAge(age)
  }

  // 西暦のみから年齢を計算して表示
  calculateAgeFromYear(event) {
    const year = event.target.value
    if (!year || year.length !== 4 || !/^\d{4}$/.test(year)) {
      this.clearAgeDisplay()
      return
    }

    const birthYear = parseInt(year)
    const currentYear = new Date().getFullYear()
    
    if (birthYear < 1900 || birthYear > currentYear) {
      this.clearAgeDisplay()
      return
    }

    // 1月1日生まれとして計算
    const age = currentYear - birthYear
    this.displayAge(age)
  }

  // 郵便番号から住所を検索
  async searchAddress(event) {
    const postalCode = event.target.value.replace(/[^0-9]/g, '')
    
    if (postalCode.length !== 7) {
      return
    }

    try {
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`)
      const data = await response.json()

      if (data.status === 200 && data.results && data.results.length > 0) {
        const result = data.results[0]
        this.fillAddress(result)
      } else {
        this.showAddressError("郵便番号が見つかりませんでした")
      }
    } catch (error) {
      console.error("住所検索エラー:", error)
      this.showAddressError("住所の取得に失敗しました")
    }
  }

  // 住所フィールドに値を設定
  fillAddress(addressData) {
    const prefectureField = document.querySelector('input[name="user_profile[prefecture]"]')
    const cityField = document.querySelector('input[name="user_profile[city]"]')

    if (prefectureField) {
      prefectureField.value = addressData.address1
    }
    
    if (cityField) {
      cityField.value = addressData.address2 + addressData.address3
    }

    // 成功メッセージを表示
    this.showAddressSuccess("住所を自動入力しました")
  }

  // 年齢を表示
  displayAge(age) {
    const ageDisplay = document.getElementById('age-display')
    if (ageDisplay) {
      ageDisplay.textContent = `${age}歳`
      ageDisplay.className = "mt-1 text-sm text-green-600"
    }
  }

  // 年齢表示をクリア
  clearAgeDisplay() {
    const ageDisplay = document.getElementById('age-display')
    if (ageDisplay) {
      ageDisplay.textContent = ""
    }
  }

  // 住所取得成功メッセージ
  showAddressSuccess(message) {
    this.showAddressMessage(message, "text-green-600")
  }

  // 住所取得エラーメッセージ
  showAddressError(message) {
    this.showAddressMessage(message, "text-red-600")
  }

  // 住所関連メッセージを表示
  showAddressMessage(message, className) {
    const postalCodeField = document.querySelector('input[name="user_profile[postal_code]"]')
    if (!postalCodeField) return

    // 既存のメッセージを削除
    const existingMessage = postalCodeField.parentNode.querySelector('.address-message')
    if (existingMessage) {
      existingMessage.remove()
    }

    // 新しいメッセージを追加
    const messageDiv = document.createElement('div')
    messageDiv.className = `mt-1 text-xs ${className} address-message`
    messageDiv.textContent = message
    postalCodeField.parentNode.appendChild(messageDiv)

    // 3秒後にメッセージを削除
    setTimeout(() => {
      if (messageDiv.parentNode) {
        messageDiv.remove()
      }
    }, 3000)
  }

  // プロフィール完成度をリアルタイム更新（将来的な拡張）
  updateCompletionRate() {
    // この機能は将来的に実装予定
    // フォームの入力状況をチェックして完成度を更新
  }
}
